var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper scroll-y custom-scrollbar view-auth"},[_c('svg',{staticClass:"logo"},[_c('use',{attrs:{"xlink:href":"#portalgastro-logo"}})]),_c('form-remind-password')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }